module.exports = __webpack_public_path__ + "img/mrl-square.b8aed828.png";